/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleChevronUp = createReactComponent(
  "circle-chevron-up",
  "IconCircleChevronUp",
  [
    ["path", { d: "M9 13l3 -3l3 3", key: "svg-0" }],
    ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-1" }]
  ]
);

export { IconCircleChevronUp as default };
//# sourceMappingURL=IconCircleChevronUp.js.map
